<template>
  <div class="box flex justify-between">
    <Logo />
    <div class="marquee" v-if="marqueeHtml">
      <div class="marquee-track" v-html="marqueeHtml"></div>
    </div>
    <HeaderRight />
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import DOMPurify from 'dompurify'
import Logo from '@/layout/default/components/header/Logo.vue'
import HeaderRight from '@/layout/default/components/header/HeaderRight.vue'
import { useCommonStore } from '@/store/useCommonStore'

const store = useCommonStore()

const sanitizeMarqueeHtml = (raw: string) =>
  DOMPurify.sanitize(raw, {
    ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'u', 'span', 'p'],
    ALLOWED_ATTR: ['style'],
    FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'svg', 'math'],
    ALLOW_UNKNOWN_PROTOCOLS: false,
  })

const marqueeHtml = computed(() => {
  const list = (store.marqueeInfo || []) as Array<any>
  const now = Date.now()
  const activeList = list
    .filter((item) => {
      const start = item?.startTime ? new Date(item.startTime).getTime() : 0
      const end = item?.endTime ? new Date(item.endTime).getTime() : Number.MAX_SAFE_INTEGER
      return now >= start && now <= end
    })
    .sort((a, b) => (a?.displayOrder ?? 0) - (b?.displayOrder ?? 0))

  if (!activeList.length) return ''

  return activeList
    .map((item) => sanitizeMarqueeHtml(String(item?.contentHtml || item?.title || '')))
    .filter(Boolean)
    .join('<span class="marquee-sep"> | </span>')
})
</script>
<style lang="scss" scoped>
.box {
  height: 100%;
  align-items: center;
}

.marquee {
  flex: 0 1 520px;
  max-width: 520px;
  margin: 0 16px;
  overflow: hidden;
  white-space: nowrap;
  height: 100%;
  display: flex;
  align-items: center;
}

.marquee-track {
  display: inline-block;
  padding-left: 100%;
  animation: marquee-scroll 18s linear infinite;
  color: #ffffff;
  font-size: 14px;
}

:deep(.marquee-sep) {
  margin: 0 12px;
  opacity: 0.7;
}

@keyframes marquee-scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}
</style>
